import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import { HeroBackground } from './HeroBackground';
import { ThinkArcLogo } from './ThinkArcLogo';
import { BeginOSDiagram } from './BeginOSDiagram';
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react";
import { motion } from "framer-motion";
import { PeerOSSection } from './PeerOSSection';

const TextScramble = ({ text, className }) => {
  const [displayText, setDisplayText] = useState('');
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+";

  useEffect(() => {
    let iteration = 0;
    const interval = setInterval(() => {
      setDisplayText(text.split("").map((letter, index) => {
        if (index < iteration) {
          return text[index];
        }
        return chars[Math.floor(Math.random() * chars.length)];
      }).join(""));

      if (iteration >= text.length) {
        clearInterval(interval);
      }

      iteration += 1 / 3;
    }, 30);

    return () => clearInterval(interval);
  }, [text]);

  return (
    <motion.span
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={className}
    >
      {displayText}
    </motion.span>
  );
};






const App = () => {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 font-sans selection:bg-blue-100 selection:text-blue-900">
      <nav className="fixed w-full z-50 bg-white/80 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <img src="/ThinkARC-logo-black.png" alt="ThinkArc" className="h-16" />
          <a href="mailto:vk@thinkarc.ai" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">
            Contact
          </a>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="min-h-[90vh] flex flex-col justify-center px-8 pt-32 pb-8 bg-white relative overflow-hidden">
        {/* New Grid Pattern & Random Boxes Background */}
        <HeroBackground />

        <div className="max-w-5xl mx-auto text-center relative z-10">
          <div className="inline-block px-4 py-2 mb-8 border border-slate-200/60 bg-white/40 backdrop-blur-sm text-slate-500 text-[10px] font-mono uppercase tracking-widest">
            Think Advanced Research Center
          </div>
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-[1.1] tracking-tight text-slate-900">
            <div className="flex flex-col">
              <TextScramble text="Where Human" className="block" />
              <TextScramble text="Intelligence Multiplies" className="block text-slate-400" />
            </div>
          </h1>
          <p className="text-xl text-slate-600 max-w-4xl mx-auto leading-relaxed font-light">
            Ending the scarcity of human expertise.
          </p>
        </div>

        {/* Backed By Indicator */}
        <div className="absolute bottom-8 right-8 z-10 hidden md:flex flex-col items-end gap-1">
          <div className="text-[10px] font-medium text-slate-400 uppercase tracking-widest text-right">
            Backed By <span className="font-bold text-slate-900">gene8tor</span> and <span className="font-bold text-slate-900">IDEABANK</span>
          </div>
          <div className="text-[10px] font-medium text-slate-400 uppercase tracking-widest text-right mt-1">
            Want to work with us? <a href="mailto:vk@thinkarc.ai" className="font-bold text-slate-900 hover:underline">vk@thinkarc.ai</a>
          </div>
        </div>
      </section>


      {/* Product Section (BeginOS) */}
      {/* <section id="product" className="pt-12 pb-24 px-8 bg-slate-50/50 border-t border-slate-100 overflow-hidden">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-center">

            <div className="flex flex-col items-start max-w-2xl">
              <div className="inline-flex items-center space-x-2 mb-6">
                <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse"></div>
                <span className="text-slate-400 text-sm font-semibold uppercase tracking-wider">Core Product</span>
              </div>
              <div className="flex items-center gap-4 mb-6">
                <h2 className="text-4xl md:text-5xl font-bold leading-tight tracking-tight">
                  <span className="text-[#059669]">Begin</span>
                  <span className="text-transparent" style={{ WebkitTextStroke: '1px #059669' }}>OS</span>
                </h2>
              </div>
              <p className="text-xl text-slate-500 mb-8 leading-relaxed">
                The first New Country operating system. Building Infrastructure for a borderless world.
              </p>

              <div className="grid md:grid-cols-2 gap-8 mb-10 w-full">
                <div className="border-l-2 border-slate-200 pl-6">
                  <h3 className="font-semibold text-slate-900 mb-1">Financial Infrastructure</h3>
                  <p className="text-slate-500">Instant access to banking and credit systems without local history.</p>
                </div>
                <div className="border-l-2 border-slate-200 pl-6">
                  <h3 className="font-semibold text-slate-900 mb-1">Compliance Infrastructure</h3>
                  <p className="text-slate-500">Automated compliance tracking backed by licensed attorneys.</p>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <a
                  href="https://beginos.co"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-[#059669] text-white px-8 py-3 rounded-md text-sm font-semibold hover:bg-[#059669]/90 transition-colors duration-200"
                >
                  Visit BeginOS.co
                </a>
              </div>
            </div>

            <div className="w-full flex justify-center lg:justify-end">
              <BeginOSDiagram />
            </div>

          </div>
        </div>
      </section > */}

      {/* PeerOS Product Section */}
      < PeerOSSection />

      {/* Footer */}
      < footer className="py-12 px-8 bg-slate-50 border-t border-slate-100" >
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center text-sm text-slate-500">
          <div className="mb-4 md:mb-0 flex flex-col md:flex-row items-center gap-4">
            <span>© {new Date().getFullYear()} ThinkArc. All rights reserved.</span>
            <span className="hidden md:inline text-slate-300">|</span>
            <span>Building Operating Systems for the World</span>
          </div>
          <div className="flex items-center space-x-6">
            <span>Based in Alabama, USA</span>
            <a href="mailto:founders@thinkarc.ai" className="text-slate-900 hover:text-black transition-colors">founders@thinkarc.ai</a>
          </div>
        </div>
      </footer >
      <SpeedInsights />
      <Analytics />
    </div >
  );
};

export default App;